export default function StudioAuthoringSettingsController() {}
